import { useCallback } from 'react'

import emDash from '~/components/emdash'

import { useNumberFormatter } from './number'
import type { FormatterHook } from './types'
import { combineOptions } from './types'
import { useUnitsFormatter } from './units'

const defaultOptions = {
  longForm: false,
  sigFigs: 1,
  units: 'V',
  omitUnits: false,
  invalidStr: emDash
}

const exportOptions = { ...defaultOptions, omitUnits: true, invalidStr: '' }

// eslint-disable-next-line import/prefer-default-export
export const useVoltageFormatter: FormatterHook = () => {
  const formatNumber = useNumberFormatter()
  const formatUnits = useUnitsFormatter()

  return useCallback(
    (value, options) => {
      const {
        value: voltage,
        longForm,
        sigFigs,
        units,
        omitUnits,
        invalidStr
      } = combineOptions({
        value,
        options,
        defaults: defaultOptions,
        exports: exportOptions
      })

      if (units !== 'V') return invalidStr
      if (typeof voltage !== 'string' && typeof voltage !== 'number') return invalidStr

      // Coerce to number
      const voltageNum = parseFloat(`${voltage}`)
      if (isNaN(voltageNum)) return invalidStr

      const voltageStr = formatNumber(voltageNum, { maximumFractionDigits: sigFigs, export: options?.export })
      if (omitUnits) return voltageStr

      const formattedUnits = formatUnits.voltage(longForm ? 'long' : 'short')
      return [voltageStr, formattedUnits].join(' ')
    },
    [formatNumber, formatUnits]
  )
}
